module.exports = __webpack_public_path__ + "img/officialaccount.7db796eb.jpg";